<template>
    <div class="v-flex">
        <v-icon size="22" color="primary" class="mr-1">{{ selected ? 'mdi-menu-down' : 'mdi-menu-right' }}</v-icon>
        <v-icon size="22" color="primary" class="mr-1">{{ selected ? 'mdi-folder-open' : 'mdi-folder' }}</v-icon>
        <div class="customer-name " :class="selected ? 'mt-2' : ''">
            {{ customer.name }}
        </div>
        <v-spacer />
        <div v-if="selected" class="unit-count">
            {{ count }}
        </div>
        <div>
            <c-toolbar-button
                v-if="selected"
                icon="mdi-filter"
                size="22"
                color="primary"
                @click="onFilter"
            />
        </div>
    </div>
</template>

<script>

import CToolbarButton from "@/modules/core/components/utils/CToolbarButton.vue";

export default {
    name: "PDmsTreeviewCustomer",
    components: {
        CToolbarButton

    },

    props: {
        customer: {

        },

        selected: {
            required: false,
            type    : Boolean,
            default : () => {
                return false;
            }
        },

        count: {

        }
    },

    watch: {
        count() {
            console.log("count changed", this.count)
        }
    },

    methods: {
        onFilter () {
            this.$emit("filter")
        }
    }
}
</script>

<style scoped>

.customer-name {
    margin-top: 4px;
    font-size: 16px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.unit-count {
    font-size: 12px;
    padding-right: 5px;
    padding-top: 9px;
}

</style>